import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: end;
  justify-content: space-between;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.md} {
    flex-direction: column;
    align-items: start;
    justify-content: center;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: start;
  justify-content: center;
  gap: 16px;

  >input {
    max-width: 100% !important;
  }
`;


export const SocialIconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    width: 100%;
    justify-content: space-between;
  }
`;

export const InputGroup = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
`;